import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { SiteFooter } from '../components/ui/SiteFooter';
import { SiteHeader } from '../components/ui/SiteHeader';
import { FoundingOffer } from '../components/practitioners/FoundingOffer';
import { foundingOffer } from '../data/foundingOffer';
export function PractitionersPage() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-930" data-mp="2za5nc8cdjf86">
      {/* Navigation */}
      <SiteHeader currentPath="/practitioners" data-id="element-931" data-mp="3s0ea6dhuunt3" />

      <main className="pt-16 md:pt-24 pb-24" data-id="element-932" data-mp="3s1p9a00cv7dv">
        {/* Intro */}
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-933" data-mp="3n0rxc55xv9kt">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-5" data-id="element-934" data-mp="3i2q9z81hco3j">
            For Practitioners
          </p>

          <h1 className="font-serif text-4xl md:text-6xl text-charcoal leading-[1.05] mb-6 tracking-tight" data-id="element-935" data-mp="2bngzz74liuk6">
            Join the Network
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-936" data-mp="zlnd0bi9fksj">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness.
          </p>
        </div>

        {/* Founding member offer */}
        <div className="max-w-3xl mx-auto px-6 mt-10" data-id="element-937" data-mp="ppkcfa323u7p">
          <div className="rounded-3xl bg-purple-800 px-7 py-8 md:px-10 md:py-9 text-center" data-id="element-938" data-mp="ul83jv13mxfu">
            <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-200" data-id="element-939" data-mp="fwbvhxz1lkf8">
              <SparklesIcon aria-hidden="true" className="w-4 h-4" data-id="element-940" data-mp="kpefpfhxjhir" />
              Founding member offer
            </p>

            <p className="mt-4 font-serif text-2xl md:text-3xl text-white leading-snug" data-id="element-941" data-mp="bwup92bskj90">
              {foundingOffer.headline}
            </p>

            <p className="mt-4 text-base text-purple-100/90 leading-relaxed max-w-xl mx-auto" data-id="element-942" data-mp="3t5zrt55uyqq3">
              {foundingOffer.subline}
            </p>

            <p className="mt-5 text-sm text-purple-200/80" data-id="element-943" data-mp="3eymu4nanxhje">
              Offer closes {foundingOffer.deadline}.
            </p>

            <a href="/practitioners/join" className="mt-7 inline-flex items-center justify-center rounded-full bg-white px-8 py-3.5 text-base font-semibold text-purple-900 transition-colors duration-200 ease-out hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-200 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-800" data-id="element-944" data-mp="3a63b3at7hu77">
              Join Fem Entity
            </a>

            <p className="mt-5 text-sm text-purple-100/90" data-id="element-945" data-mp="3ny9st1c0c98r">
              Already a member?{' '}
              <a href="/practitioners/account/membership" className="font-semibold text-white underline underline-offset-4 decoration-purple-300 hover:text-purple-100 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-200" data-id="element-946" data-mp="3j0rgr22p1dwj">
                Manage your membership
              </a>
            </p>
          </div>
        </div>

        {/* Offer detail */}
        <div className="max-w-3xl mx-auto px-6 mt-20 md:mt-24" data-id="element-947" data-mp="s2en2pby811s">
          <FoundingOffer data-id="element-948" data-mp="x0okl6l5bdqk" />
        </div>

        {/* Application form */}
        <section id="apply" aria-labelledby="apply-heading" className="max-w-3xl mx-auto px-6 mt-20 md:mt-24 scroll-mt-28" data-id="element-949" data-mp="11rol0lth4dxt">
          <div className="rounded-3xl border border-purple-200 bg-white px-7 py-10 md:px-12 md:py-12 text-center shadow-[0_18px_50px_-30px_rgba(44,44,44,0.5)]" data-id="element-950" data-mp="16qhxcax0xywe">
            <h2 id="apply-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-951" data-mp="1fr6cj8y5m5av">
              Ready to join?
            </h2>

            <p className="mt-4 max-w-xl mx-auto text-base text-charcoal/70 leading-relaxed" data-id="element-952" data-mp="3hjm57x25dzim">
              Create your account and choose your membership here, then complete
              your practitioner profile and verification in the Fem Entity app.
            </p>

            <a href="/practitioners/join" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-purple-700 px-8 py-4 text-base font-semibold text-white transition-colors duration-200 ease-out hover:bg-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-953" data-mp="1buipeavvt9xn">
              Join Fem Entity
              <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-954" data-mp="t5c2ebo21w61" />
            </a>

            <p className="mt-5 text-sm text-charcoal/60" data-id="element-955" data-mp="16xjuvr8b30yx">
              Need to manage your plan?{' '}
              <a href="/practitioners/account/membership" className="font-semibold text-purple-700 underline underline-offset-4 decoration-purple-300 hover:text-purple-900 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600" data-id="element-956" data-mp="122w75ul4male">
                Manage your Membership
              </a>
            </p>
          </div>
        </section>
      </main>

      <SiteFooter currentPath="/practitioners" data-id="element-957" data-mp="3mh2ptnp2waah" />
    </div>;
}